<template>
 <div class="relative select-none scroll-smooth">
  <!-- cover -->
  <div id="cover" class="w-screen h-screen fixed main-bg z-30">
    <div class="absolute bottom-0 right-0 left-0 text-white flex flex-col z-20" :class="isGuestExists ? 'h-full lg:h-4/5 justify-around' : 'h-full justify-center'">
      <div class="text-center">
         <h1 class="display-fair text-2xl lg:text-4xl mb-10">THE WEDDING OF</h1>
         <h1 class="great-vibes text-3xl lg:text-8xl">{{ `${wedding.wife_nickname} & ${wedding.husband_nickname}` }}</h1>
      </div>
      <div v-if="isGuestExists" class="items-center flex flex-col constantia">
        <span class="mb-3 text-2xl lg:text-4xl font-semibold"> Hello, {{ wedding.guests[0].name }}</span>
        <span class="mb-5 text-xl lg:text-2xl">
              You are invited
        </span>
        <button class="thm2-btn max-w-max" @click="openInvitation">Open Invitation</button>
      </div>
    </div>
  </div>
  <!-- cover end -->
  <div id="body" class="hidden">

    <div id="surah" class="surah-cover relative z-20 h-screen min-h-max grid place-items-center">
     <div class="text-center display-fair">
      <h2 class="text-4xl mb-5" style="color: #314260;">{{ wedding.surah }}</h2>
      <p class="text-xl italic font-semibold w-4/5 mx-auto" v-html=" wedding.surah_detail" />
     </div>
    </div>

    <!-- person  -->
    <div id="person" class="person-cover h-screen md:h-full flex flex-col justify-around z-0 -translate-y-24" :style="`background-image: url(${personBgImage})`">
      <div class="text-white w-5/6 mx-auto z-10 display-fair flex flex-col gap-10">
        <div class="lg:mb-9 flex flex-col items-center lg:items-start lg:self-start">
          <div class="text-2xl lg:text-5xl mb-4 text-center lg:text-right">{{ wedding.wife }}</div>
          <div class="text-base mb-4 text-center lg:text-left flex flex-col lg:flex-row"><span>Putri Bapak {{ wedding.wife_father }}</span> <span class="hidden lg:block mx-2">{{ ' - ' }}</span> <span class="lg:hidden">&</span> <span>Ibu {{ wedding.wife_mother }}</span></div>
          <div id="social-media" class="flex flex-row gap-4">
            <a v-if="wedding.wife_instagram" class="flex flex-row gap-4" :href="wedding.wife_instagram" target="_blank">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.465 1.566C8.638 1.512 9.012 1.5 12 1.5C14.988 1.5 15.362 1.513 16.534 1.566C17.706 1.619 18.506 1.806 19.206 2.077C19.939 2.354 20.604 2.787 21.154 3.347C21.714 3.896 22.146 4.56 22.422 5.294C22.694 5.994 22.88 6.794 22.934 7.964C22.988 9.139 23 9.513 23 12.5C23 15.488 22.987 15.862 22.934 17.035C22.881 18.205 22.694 19.005 22.422 19.705C22.146 20.4391 21.7133 21.1042 21.154 21.654C20.604 22.214 19.939 22.646 19.206 22.922C18.506 23.194 17.706 23.38 16.536 23.434C15.362 23.488 14.988 23.5 12 23.5C9.012 23.5 8.638 23.487 7.465 23.434C6.295 23.381 5.495 23.194 4.795 22.922C4.06092 22.646 3.39582 22.2133 2.846 21.654C2.28638 21.1047 1.85331 20.4399 1.577 19.706C1.306 19.006 1.12 18.206 1.066 17.036C1.012 15.861 1 15.487 1 12.5C1 9.512 1.013 9.138 1.066 7.966C1.119 6.794 1.306 5.994 1.577 5.294C1.85372 4.56008 2.28712 3.89531 2.847 3.346C3.39604 2.7865 4.06047 2.35344 4.794 2.077C5.494 1.806 6.294 1.62 7.464 1.566H7.465ZM16.445 3.546C15.285 3.493 14.937 3.482 12 3.482C9.063 3.482 8.715 3.493 7.555 3.546C6.482 3.595 5.9 3.774 5.512 3.925C4.999 4.125 4.632 4.362 4.247 4.747C3.88205 5.10205 3.60118 5.53428 3.425 6.012C3.274 6.4 3.095 6.982 3.046 8.055C2.993 9.215 2.982 9.563 2.982 12.5C2.982 15.437 2.993 15.785 3.046 16.945C3.095 18.018 3.274 18.6 3.425 18.988C3.601 19.465 3.882 19.898 4.247 20.253C4.602 20.618 5.035 20.899 5.512 21.075C5.9 21.226 6.482 21.405 7.555 21.454C8.715 21.507 9.062 21.518 12 21.518C14.938 21.518 15.285 21.507 16.445 21.454C17.518 21.405 18.1 21.226 18.488 21.075C19.001 20.875 19.368 20.638 19.753 20.253C20.118 19.898 20.399 19.465 20.575 18.988C20.726 18.6 20.905 18.018 20.954 16.945C21.007 15.785 21.018 15.437 21.018 12.5C21.018 9.563 21.007 9.215 20.954 8.055C20.905 6.982 20.726 6.4 20.575 6.012C20.375 5.499 20.138 5.132 19.753 4.747C19.3979 4.38207 18.9657 4.10121 18.488 3.925C18.1 3.774 17.518 3.595 16.445 3.546ZM10.595 15.891C11.3797 16.2176 12.2534 16.2617 13.0669 16.0157C13.8805 15.7697 14.5834 15.2489 15.0556 14.5422C15.5278 13.8356 15.7401 12.9869 15.656 12.1411C15.572 11.2953 15.197 10.505 14.595 9.905C14.2112 9.52148 13.7472 9.22781 13.2363 9.04515C12.7255 8.86248 12.1804 8.79536 11.6405 8.84862C11.1006 8.90187 10.5792 9.07418 10.1138 9.35313C9.64845 9.63208 9.25074 10.0107 8.9493 10.4619C8.64786 10.913 8.45019 11.4253 8.37052 11.962C8.29084 12.4986 8.33115 13.0463 8.48854 13.5655C8.64593 14.0847 8.91648 14.5626 9.28072 14.9647C9.64496 15.3668 10.0938 15.6832 10.595 15.891ZM8.002 8.502C8.52702 7.97697 9.15032 7.5605 9.8363 7.27636C10.5223 6.99222 11.2575 6.84597 12 6.84597C12.7425 6.84597 13.4777 6.99222 14.1637 7.27636C14.8497 7.5605 15.473 7.97697 15.998 8.502C16.523 9.02702 16.9395 9.65032 17.2236 10.3363C17.5078 11.0223 17.654 11.7575 17.654 12.5C17.654 13.2425 17.5078 13.9777 17.2236 14.6637C16.9395 15.3497 16.523 15.973 15.998 16.498C14.9377 17.5583 13.4995 18.154 12 18.154C10.5005 18.154 9.06234 17.5583 8.002 16.498C6.94166 15.4377 6.34597 13.9995 6.34597 12.5C6.34597 11.0005 6.94166 9.56234 8.002 8.502ZM18.908 7.688C19.0381 7.56527 19.1423 7.41768 19.2143 7.25397C19.2863 7.09027 19.3248 6.91377 19.3274 6.73493C19.33 6.55609 19.2967 6.37855 19.2295 6.21281C19.1622 6.04707 19.0624 5.89651 18.936 5.77004C18.8095 5.64357 18.6589 5.54376 18.4932 5.47652C18.3275 5.40928 18.1499 5.37598 17.9711 5.37858C17.7922 5.38119 17.6157 5.41965 17.452 5.4917C17.2883 5.56374 17.1407 5.6679 17.018 5.798C16.7793 6.05103 16.6486 6.38712 16.6537 6.73493C16.6588 7.08274 16.7992 7.41488 17.0452 7.66084C17.2911 7.90681 17.6233 8.04723 17.9711 8.0523C18.3189 8.05737 18.655 7.92669 18.908 7.688Z" fill="white"/>
              </svg>
              <span>INSTAGRAM</span>
            </a>
            <a v-if="wedding.wife_twitter" class="flex flex-row gap-4" :href="wedding.wife_twitter" target="_blank">
              <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.6428 2.43718C22.8078 2.80718 21.9108 3.05718 20.9678 3.17018C21.9408 2.58797 22.6687 1.67164 23.0158 0.592176C22.1016 1.13517 21.1011 1.51737 20.0578 1.72218C19.3561 0.973041 18.4268 0.476502 17.4141 0.30965C16.4014 0.142798 15.3619 0.314968 14.457 0.799429C13.5521 1.28389 12.8325 2.05354 12.4099 2.98888C11.9873 3.92422 11.8853 4.97293 12.1198 5.97218C10.2675 5.87917 8.4554 5.39773 6.80119 4.55908C5.14699 3.72044 3.68761 2.54334 2.51777 1.10418C2.11777 1.79418 1.88777 2.59418 1.88777 3.44618C1.88732 4.21317 2.0762 4.96842 2.43765 5.64491C2.79909 6.3214 3.32193 6.89821 3.95977 7.32418C3.22004 7.30064 2.49664 7.10076 1.84977 6.74118V6.80118C1.84969 7.87692 2.2218 8.91955 2.90295 9.75217C3.5841 10.5848 4.53234 11.1561 5.58677 11.3692C4.90055 11.5549 4.18111 11.5822 3.48277 11.4492C3.78026 12.3748 4.35976 13.1842 5.14013 13.7641C5.92051 14.344 6.86268 14.6654 7.83477 14.6832C6.1846 15.9786 4.14665 16.6813 2.04877 16.6782C1.67715 16.6783 1.30584 16.6566 0.936768 16.6132C3.06624 17.9824 5.54511 18.709 8.07677 18.7062C16.6468 18.7062 21.3318 11.6082 21.3318 5.45218C21.3318 5.25218 21.3268 5.05018 21.3178 4.85018C22.2291 4.19115 23.0157 3.37507 23.6408 2.44018L23.6428 2.43718Z" fill="white"/>
              </svg>
              <span>TWITTER</span>
            </a>
          </div>
        </div>
        <div class="border-b-2 border-white lg:border-b-0 "></div>
         <div class="lg:self-end flex flex-col items-center lg:items-start">
          <div class="text-2xl lg:text-5xl mb-4 text-center lg:text-right">{{ wedding.husband }}</div>
          <div class="text-base mb-4 text-center lg:text-left flex flex-col lg:flex-row"><span>Putra Bapak {{ wedding.husband_father }}</span> <span class="hidden lg:block mx-2">{{ ' - ' }}</span> <span class="lg:hidden">&</span> <span>Ibu {{ wedding.husband_mother }}</span></div>
            <div id="social-media" class="flex flex-row gap-4">
             <a v-if="wedding.husband_instagram" class="flex flex-row gap-4" :href="wedding.husband_instagram" target="_blank">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.465 1.566C8.638 1.512 9.012 1.5 12 1.5C14.988 1.5 15.362 1.513 16.534 1.566C17.706 1.619 18.506 1.806 19.206 2.077C19.939 2.354 20.604 2.787 21.154 3.347C21.714 3.896 22.146 4.56 22.422 5.294C22.694 5.994 22.88 6.794 22.934 7.964C22.988 9.139 23 9.513 23 12.5C23 15.488 22.987 15.862 22.934 17.035C22.881 18.205 22.694 19.005 22.422 19.705C22.146 20.4391 21.7133 21.1042 21.154 21.654C20.604 22.214 19.939 22.646 19.206 22.922C18.506 23.194 17.706 23.38 16.536 23.434C15.362 23.488 14.988 23.5 12 23.5C9.012 23.5 8.638 23.487 7.465 23.434C6.295 23.381 5.495 23.194 4.795 22.922C4.06092 22.646 3.39582 22.2133 2.846 21.654C2.28638 21.1047 1.85331 20.4399 1.577 19.706C1.306 19.006 1.12 18.206 1.066 17.036C1.012 15.861 1 15.487 1 12.5C1 9.512 1.013 9.138 1.066 7.966C1.119 6.794 1.306 5.994 1.577 5.294C1.85372 4.56008 2.28712 3.89531 2.847 3.346C3.39604 2.7865 4.06047 2.35344 4.794 2.077C5.494 1.806 6.294 1.62 7.464 1.566H7.465ZM16.445 3.546C15.285 3.493 14.937 3.482 12 3.482C9.063 3.482 8.715 3.493 7.555 3.546C6.482 3.595 5.9 3.774 5.512 3.925C4.999 4.125 4.632 4.362 4.247 4.747C3.88205 5.10205 3.60118 5.53428 3.425 6.012C3.274 6.4 3.095 6.982 3.046 8.055C2.993 9.215 2.982 9.563 2.982 12.5C2.982 15.437 2.993 15.785 3.046 16.945C3.095 18.018 3.274 18.6 3.425 18.988C3.601 19.465 3.882 19.898 4.247 20.253C4.602 20.618 5.035 20.899 5.512 21.075C5.9 21.226 6.482 21.405 7.555 21.454C8.715 21.507 9.062 21.518 12 21.518C14.938 21.518 15.285 21.507 16.445 21.454C17.518 21.405 18.1 21.226 18.488 21.075C19.001 20.875 19.368 20.638 19.753 20.253C20.118 19.898 20.399 19.465 20.575 18.988C20.726 18.6 20.905 18.018 20.954 16.945C21.007 15.785 21.018 15.437 21.018 12.5C21.018 9.563 21.007 9.215 20.954 8.055C20.905 6.982 20.726 6.4 20.575 6.012C20.375 5.499 20.138 5.132 19.753 4.747C19.3979 4.38207 18.9657 4.10121 18.488 3.925C18.1 3.774 17.518 3.595 16.445 3.546ZM10.595 15.891C11.3797 16.2176 12.2534 16.2617 13.0669 16.0157C13.8805 15.7697 14.5834 15.2489 15.0556 14.5422C15.5278 13.8356 15.7401 12.9869 15.656 12.1411C15.572 11.2953 15.197 10.505 14.595 9.905C14.2112 9.52148 13.7472 9.22781 13.2363 9.04515C12.7255 8.86248 12.1804 8.79536 11.6405 8.84862C11.1006 8.90187 10.5792 9.07418 10.1138 9.35313C9.64845 9.63208 9.25074 10.0107 8.9493 10.4619C8.64786 10.913 8.45019 11.4253 8.37052 11.962C8.29084 12.4986 8.33115 13.0463 8.48854 13.5655C8.64593 14.0847 8.91648 14.5626 9.28072 14.9647C9.64496 15.3668 10.0938 15.6832 10.595 15.891ZM8.002 8.502C8.52702 7.97697 9.15032 7.5605 9.8363 7.27636C10.5223 6.99222 11.2575 6.84597 12 6.84597C12.7425 6.84597 13.4777 6.99222 14.1637 7.27636C14.8497 7.5605 15.473 7.97697 15.998 8.502C16.523 9.02702 16.9395 9.65032 17.2236 10.3363C17.5078 11.0223 17.654 11.7575 17.654 12.5C17.654 13.2425 17.5078 13.9777 17.2236 14.6637C16.9395 15.3497 16.523 15.973 15.998 16.498C14.9377 17.5583 13.4995 18.154 12 18.154C10.5005 18.154 9.06234 17.5583 8.002 16.498C6.94166 15.4377 6.34597 13.9995 6.34597 12.5C6.34597 11.0005 6.94166 9.56234 8.002 8.502ZM18.908 7.688C19.0381 7.56527 19.1423 7.41768 19.2143 7.25397C19.2863 7.09027 19.3248 6.91377 19.3274 6.73493C19.33 6.55609 19.2967 6.37855 19.2295 6.21281C19.1622 6.04707 19.0624 5.89651 18.936 5.77004C18.8095 5.64357 18.6589 5.54376 18.4932 5.47652C18.3275 5.40928 18.1499 5.37598 17.9711 5.37858C17.7922 5.38119 17.6157 5.41965 17.452 5.4917C17.2883 5.56374 17.1407 5.6679 17.018 5.798C16.7793 6.05103 16.6486 6.38712 16.6537 6.73493C16.6588 7.08274 16.7992 7.41488 17.0452 7.66084C17.2911 7.90681 17.6233 8.04723 17.9711 8.0523C18.3189 8.05737 18.655 7.92669 18.908 7.688Z" fill="white"/>
              </svg>
              <span>INSTAGRAM</span>
            </a>
            <a v-if="wedding.husband_twitter" class="flex flex-row gap-4" :href="wedding.husband_twitter" target="_blank">
               <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.6428 2.43718C22.8078 2.80718 21.9108 3.05718 20.9678 3.17018C21.9408 2.58797 22.6687 1.67164 23.0158 0.592176C22.1016 1.13517 21.1011 1.51737 20.0578 1.72218C19.3561 0.973041 18.4268 0.476502 17.4141 0.30965C16.4014 0.142798 15.3619 0.314968 14.457 0.799429C13.5521 1.28389 12.8325 2.05354 12.4099 2.98888C11.9873 3.92422 11.8853 4.97293 12.1198 5.97218C10.2675 5.87917 8.4554 5.39773 6.80119 4.55908C5.14699 3.72044 3.68761 2.54334 2.51777 1.10418C2.11777 1.79418 1.88777 2.59418 1.88777 3.44618C1.88732 4.21317 2.0762 4.96842 2.43765 5.64491C2.79909 6.3214 3.32193 6.89821 3.95977 7.32418C3.22004 7.30064 2.49664 7.10076 1.84977 6.74118V6.80118C1.84969 7.87692 2.2218 8.91955 2.90295 9.75217C3.5841 10.5848 4.53234 11.1561 5.58677 11.3692C4.90055 11.5549 4.18111 11.5822 3.48277 11.4492C3.78026 12.3748 4.35976 13.1842 5.14013 13.7641C5.92051 14.344 6.86268 14.6654 7.83477 14.6832C6.1846 15.9786 4.14665 16.6813 2.04877 16.6782C1.67715 16.6783 1.30584 16.6566 0.936768 16.6132C3.06624 17.9824 5.54511 18.709 8.07677 18.7062C16.6468 18.7062 21.3318 11.6082 21.3318 5.45218C21.3318 5.25218 21.3268 5.05018 21.3178 4.85018C22.2291 4.19115 23.0157 3.37507 23.6408 2.44018L23.6428 2.43718Z" fill="white"/>
              </svg>
              <span>TWITTER</span>
            </a>
          </div>
        </div>
      </div>
      <img class="absolute bottom-0 lg:-bottom-10 z-10 w-screen translate-y-1 lg:translate-y-20" src="~/assets/images/theme2/wave-white.svg" alt="">
    </div>
    <!-- person end  -->
    
    <!-- event -->
    <div v-if="wedding.events" id="event" class="relative min-h-max constantia pb-10">
      <img src="~/assets/images/theme2/backdrop-1.svg" class="absolute right-0 bottom-0 -z-10" alt="bc-1">
      <img src="~/assets/images/theme2/backdrop-2.svg" class="absolute left-0 top-0 -z-10" alt="bc-2">
      <img src="~/assets/images/theme2/backdrop-3.svg" class="absolute left-0 bottom-0 -z-10" alt="bc-3">
      <img class="absolute bottom-0 lg:-bottom-10 z-10 w-screen translate-y-1 lg:translate-y-20" src="~/assets/images/theme2/wave-blue.svg" alt="">

      <div v-for="(event, index) in wedding.events" :id="event.name" :key="index" class="w-4/5 lg:w-full mx-auto flex flex-col justify-center items-center text-center mb-14" style="color: #314260;">
        <h1 class="italic text-4xl lg:text-8xl mb-6">{{ event.name }}</h1>
        <div class="text-2xl lg:text-5xl flex flex-col lg:grid lg:grid-cols-4 gap-5 lg:gap-10 items-center mt-10">
          <div class="">{{ $moment(event.date).format('dddd') }}</div>
          <div class="border-y-4 lg:border-y-0 lg:border-x-4 lg:mb-6 lg:col-span-2 py-5 lg:py-10 px-10" style="border-color: #D5E7E7">
            <div class="mb-6">{{ $moment(event.date).format('MMMM') }}</div>
            <div>{{ $moment(event.date).format('DD') }}</div>
          </div>
          <div class="">{{ $moment(event.date).format('YYYY') }}</div> 
        </div>
       <div class="mt-10 lg:mt-0 text-xl lg:text-3xl">
         <h2>Waktu :</h2>
          <span>{{ $moment(event.date).format('LT') }} WIB</span>
       </div>
      </div>

      <div id="place" class="w-4/5 mx-auto flex flex-col justify-center items-center text-center mb-14">
        <h2 class="text-xl lg:text-3xl font-semibold">{{ wedding.address }}</h2>
        <p class="text-base lg:text-2xl mb-8">{{ wedding.address_detail }}</p>
        <a class="max-w-max lg:max-w-full lg:w-full flex flex-row justify-center display-fair text-base lg:text-2xl border-2 gap-2 lg:gap-10 w-full p-3 lg:p-5 rounded-sm" style="border-color: #314260;" :href="wedding.google_maps_link" target="_blank">
          <span>Google Maps</span>
          <svg class="w-5 h-5 lg:w-9 lg:h-9" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.00298 14.307C2.96848 14.9235 3.31348 15.498 3.87448 15.756L15.1305 20.919L20.2935 32.1735C20.5395 32.7075 21.0735 33.048 21.657 33.048L21.7425 33.045C22.0435 33.0281 22.3325 32.9209 22.5717 32.7374C22.8109 32.5538 22.9893 32.3024 23.0835 32.016L31.476 6.46798C31.6515 5.93098 31.5105 5.33848 31.1115 4.93798C30.7125 4.53748 30.1215 4.40098 29.5815 4.57348L4.03198 12.9675C3.74545 13.061 3.49388 13.239 3.31026 13.478C3.12664 13.7171 3.01953 14.006 3.00298 14.307Z" fill="#314260"/>
          </svg>
        </a>
      </div>

       <div id="time" class="w-full lg:w-4/5 mx-auto flex flex-col justify-center items-center text-center mb-14 z-10" style="color: #314260;">
        <h1 class="italic text-2xl lg:text-4xl mb-6">MENUJU HARI BAHAGIA</h1>
        <div class="text-5xl grid grid-cols-3 gap-5 lg:gap-10 items-center">
          <div class="p-3 lg:p-10">
            <div class="text-3xl lg:text-6xl mb-6">{{ countdownData.days }}</div>
            <div class="text-xl lg:text-3xl">Hari</div>
          </div>
            <div class="border-x-4 py-2 lg:py-10 px-10 lg:px-20" style="border-color: #D5E7E7">
            <div class="text-3xl lg:text-6xl mb-6">{{ countdownData.hours }}</div>
            <div class="text-xl lg:text-3xl">Jam</div>
          </div>
            <div class="p-3 lg:p-10">
            <div class="text-3xl lg:text-6xl mb-6">{{ countdownData.minutes }}</div>
            <div class="text-xl lg:text-3xl">Menit</div>
          </div>
        </div>
      </div>
    </div>
    <!-- event end -->

    <!-- love story -->
    <div id="love-story" class="text-center grid place-items-center constantia text-white pt-24" style="background-color: #314260">
     <div class="mt-4 lg:mt-9 mb-5 w-4/5 lg:w-3/5 mx-auto">
       <h1 class="text-2xl lg:text-4xl mb-5 text-white">Our Love Story</h1>
        <div v-if="wedding.timelines" class="grid grid-cols-1 lg:grid-cols-3 text-base lg:text-xl my-14">
          <div v-for="(timeline, index) in wedding.timelines" v-show="index < 3" :key="index" class="p-10" :class="index < (3-1) && 'border-b-2 lg:border-b-0 lg:border-r-2 border-gray-400'">
            <div class="mb-5">{{ timeline.date }}</div>
            <div>{{ timeline.description }}</div>
          </div>
        </div>
     </div>
    </div>
    <!-- love story end -->

    <!-- prewedding gallery -->
    <div id="gallery" class="relative flex flex-col items-center justify-center p-3 lg:p-5" style="background-color: #314260;">
        <h1
          class="text-center text-white display-fair italic font-bold text-2xl lg:text-4xl"
          >Prewedding Gallery</h1>
        <div
          v-if="wedding.gallery"
          id="gallery"
          class="flex flex-row w-full gap-3 my-10 overflow-x-auto lg:justify-center lg:w-5/6 lg:flex-wrap"
        >
          <img
            v-for="(image, i) in wedding.gallery"
            :id="`image-${i}`"
            :key="i"
            :src="image.url"
            alt=""
            class="rounded-sm cursor-pointer max-h-60"
          />
        </div>
      <img class="absolute bottom-0 lg:-bottom-10 z-10 w-screen translate-y-1 lg:translate-y-28" src="~/assets/images/theme2/wave-white.svg" alt="">
    </div>
    <!-- prewedding gallery end -->

    <!-- rsvp -->
     <div class="mt-24 lg:mt-48 relative min-h-max overflow-hidden">
        <div class="text-center mb-10 px-5 lg:px-0">
          <h1 class="font-bold italic text-2xl lg:text-4xl display-fair mb-3" style="color: #314260;">RSVP</h1>
            <span class="constantia text-base lg:text-xl"> <i class="text-red-500">*</i> Diharapkan Kepada Tamu Undangan Untuk Mengisi Form Kehadiran Dibawah Ini</span>
        </div>
        <img src="~/assets/images/theme2/backdrop-1.svg" class="absolute left-0 top-0 rotate-180 -z-10" alt="bc-1">
        <img src="~/assets/images/theme2/backdrop-1.svg" class="absolute right-0 bottom-0 -z-10" alt="bc-2">
        <img src="~/assets/images/theme2/wave-small-blue.svg" class="absolute -bottom-2 lg:bottom-0 -z-10" style="min-width: -webkit-fill-available;" alt="bc-3">
        <rsvp-form :attendances="attendances" :guest="wedding.guests[0]" :wedding="wedding" class="pb-28 px-5 lg:px-0" @onGetAttendance="getAttendances" />
     </div>
    <!-- rsvp end  -->

    <div id="thankyou" class="text-white pt-24" style="background-color: #314260; max-width:-webkit-fill-available;">
      <h1 class="display-fair font-bold italic text-2xl lg:text-4xl text-center">Terima Kasih</h1>
      <p class="text-center mb-10 constantia">Merupakan suatu kebahagiaan dan kehormatan bagi kami, apabila Bapak/Ibu/Saudara/i, berkenan hadir dan memberikan do’a restu kepada Kami.</p>
      <div class="h-96 w-screen overflow-hidden relative scroll-smooth">
         <div v-if="infiniteGallery" class="scroll-element primary flex flex-nowrap">
           <img
            v-for="(image, i) in infiniteGallery"
            :id="`image-${i}`"
            :key="i"
            :src="image.url"
            alt=""
            class="rounded-md cursor-pointer max-h-60 mr-5"
          />
      </div>
      </div>
    </div>

  <footer
    id="footer"
    class="justify-center py-5 text-sm text-white constantia"
    style="background-color: #314260"
>
    <div
      class="flex flex-col-reverse items-center justify-between w-full gap-3 mx-auto lg:flex-row lg:w-1/2 lg:w-1/5 xl:w-1/5"
    >
      <a href="https://bellioo.com/id" target="_blank">
        Bellioo &#169; {{ $moment().format('YYYY') }}.
      </a>

      <div class="flex flex-row gap-3">
        <a
          href="https://www.twitter.com/andriarfazzan/"
          class="cursor-pointer"
          target="_blank"
        >
         <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.6428 2.43718C22.8078 2.80718 21.9108 3.05718 20.9678 3.17018C21.9408 2.58797 22.6687 1.67164 23.0158 0.592176C22.1016 1.13517 21.1011 1.51737 20.0578 1.72218C19.3561 0.973041 18.4268 0.476502 17.4141 0.30965C16.4014 0.142798 15.3619 0.314968 14.457 0.799429C13.5521 1.28389 12.8325 2.05354 12.4099 2.98888C11.9873 3.92422 11.8853 4.97293 12.1198 5.97218C10.2675 5.87917 8.4554 5.39773 6.80119 4.55908C5.14699 3.72044 3.68761 2.54334 2.51777 1.10418C2.11777 1.79418 1.88777 2.59418 1.88777 3.44618C1.88732 4.21317 2.0762 4.96842 2.43765 5.64491C2.79909 6.3214 3.32193 6.89821 3.95977 7.32418C3.22004 7.30064 2.49664 7.10076 1.84977 6.74118V6.80118C1.84969 7.87692 2.2218 8.91955 2.90295 9.75217C3.5841 10.5848 4.53234 11.1561 5.58677 11.3692C4.90055 11.5549 4.18111 11.5822 3.48277 11.4492C3.78026 12.3748 4.35976 13.1842 5.14013 13.7641C5.92051 14.344 6.86268 14.6654 7.83477 14.6832C6.1846 15.9786 4.14665 16.6813 2.04877 16.6782C1.67715 16.6783 1.30584 16.6566 0.936768 16.6132C3.06624 17.9824 5.54511 18.709 8.07677 18.7062C16.6468 18.7062 21.3318 11.6082 21.3318 5.45218C21.3318 5.25218 21.3268 5.05018 21.3178 4.85018C22.2291 4.19115 23.0157 3.37507 23.6408 2.44018L23.6428 2.43718Z" fill="white"/>
          </svg>
        </a>

        <a
          href="https://www.instagram.com/bellioo.app/"
          class="cursor-pointer"
          target="_blank"
        >
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.465 1.566C8.638 1.512 9.012 1.5 12 1.5C14.988 1.5 15.362 1.513 16.534 1.566C17.706 1.619 18.506 1.806 19.206 2.077C19.939 2.354 20.604 2.787 21.154 3.347C21.714 3.896 22.146 4.56 22.422 5.294C22.694 5.994 22.88 6.794 22.934 7.964C22.988 9.139 23 9.513 23 12.5C23 15.488 22.987 15.862 22.934 17.035C22.881 18.205 22.694 19.005 22.422 19.705C22.146 20.4391 21.7133 21.1042 21.154 21.654C20.604 22.214 19.939 22.646 19.206 22.922C18.506 23.194 17.706 23.38 16.536 23.434C15.362 23.488 14.988 23.5 12 23.5C9.012 23.5 8.638 23.487 7.465 23.434C6.295 23.381 5.495 23.194 4.795 22.922C4.06092 22.646 3.39582 22.2133 2.846 21.654C2.28638 21.1047 1.85331 20.4399 1.577 19.706C1.306 19.006 1.12 18.206 1.066 17.036C1.012 15.861 1 15.487 1 12.5C1 9.512 1.013 9.138 1.066 7.966C1.119 6.794 1.306 5.994 1.577 5.294C1.85372 4.56008 2.28712 3.89531 2.847 3.346C3.39604 2.7865 4.06047 2.35344 4.794 2.077C5.494 1.806 6.294 1.62 7.464 1.566H7.465ZM16.445 3.546C15.285 3.493 14.937 3.482 12 3.482C9.063 3.482 8.715 3.493 7.555 3.546C6.482 3.595 5.9 3.774 5.512 3.925C4.999 4.125 4.632 4.362 4.247 4.747C3.88205 5.10205 3.60118 5.53428 3.425 6.012C3.274 6.4 3.095 6.982 3.046 8.055C2.993 9.215 2.982 9.563 2.982 12.5C2.982 15.437 2.993 15.785 3.046 16.945C3.095 18.018 3.274 18.6 3.425 18.988C3.601 19.465 3.882 19.898 4.247 20.253C4.602 20.618 5.035 20.899 5.512 21.075C5.9 21.226 6.482 21.405 7.555 21.454C8.715 21.507 9.062 21.518 12 21.518C14.938 21.518 15.285 21.507 16.445 21.454C17.518 21.405 18.1 21.226 18.488 21.075C19.001 20.875 19.368 20.638 19.753 20.253C20.118 19.898 20.399 19.465 20.575 18.988C20.726 18.6 20.905 18.018 20.954 16.945C21.007 15.785 21.018 15.437 21.018 12.5C21.018 9.563 21.007 9.215 20.954 8.055C20.905 6.982 20.726 6.4 20.575 6.012C20.375 5.499 20.138 5.132 19.753 4.747C19.3979 4.38207 18.9657 4.10121 18.488 3.925C18.1 3.774 17.518 3.595 16.445 3.546ZM10.595 15.891C11.3797 16.2176 12.2534 16.2617 13.0669 16.0157C13.8805 15.7697 14.5834 15.2489 15.0556 14.5422C15.5278 13.8356 15.7401 12.9869 15.656 12.1411C15.572 11.2953 15.197 10.505 14.595 9.905C14.2112 9.52148 13.7472 9.22781 13.2363 9.04515C12.7255 8.86248 12.1804 8.79536 11.6405 8.84862C11.1006 8.90187 10.5792 9.07418 10.1138 9.35313C9.64845 9.63208 9.25074 10.0107 8.9493 10.4619C8.64786 10.913 8.45019 11.4253 8.37052 11.962C8.29084 12.4986 8.33115 13.0463 8.48854 13.5655C8.64593 14.0847 8.91648 14.5626 9.28072 14.9647C9.64496 15.3668 10.0938 15.6832 10.595 15.891ZM8.002 8.502C8.52702 7.97697 9.15032 7.5605 9.8363 7.27636C10.5223 6.99222 11.2575 6.84597 12 6.84597C12.7425 6.84597 13.4777 6.99222 14.1637 7.27636C14.8497 7.5605 15.473 7.97697 15.998 8.502C16.523 9.02702 16.9395 9.65032 17.2236 10.3363C17.5078 11.0223 17.654 11.7575 17.654 12.5C17.654 13.2425 17.5078 13.9777 17.2236 14.6637C16.9395 15.3497 16.523 15.973 15.998 16.498C14.9377 17.5583 13.4995 18.154 12 18.154C10.5005 18.154 9.06234 17.5583 8.002 16.498C6.94166 15.4377 6.34597 13.9995 6.34597 12.5C6.34597 11.0005 6.94166 9.56234 8.002 8.502ZM18.908 7.688C19.0381 7.56527 19.1423 7.41768 19.2143 7.25397C19.2863 7.09027 19.3248 6.91377 19.3274 6.73493C19.33 6.55609 19.2967 6.37855 19.2295 6.21281C19.1622 6.04707 19.0624 5.89651 18.936 5.77004C18.8095 5.64357 18.6589 5.54376 18.4932 5.47652C18.3275 5.40928 18.1499 5.37598 17.9711 5.37858C17.7922 5.38119 17.6157 5.41965 17.452 5.4917C17.2883 5.56374 17.1407 5.6679 17.018 5.798C16.7793 6.05103 16.6486 6.38712 16.6537 6.73493C16.6588 7.08274 16.7992 7.41488 17.0452 7.66084C17.2911 7.90681 17.6233 8.04723 17.9711 8.0523C18.3189 8.05737 18.655 7.92669 18.908 7.688Z" fill="white"/>
          </svg>
        </a>
      </div>
    </div>
  </footer>

  <audio-player :url="wedding.songs[0].url" :is-playing="isPlaying" />
  </div>
 </div>
</template>

<script>
import { getCountDown } from '~/common/helper/date'
import 'moment/locale/id';
import rsvpForm from '~/components/common/rsvpForm.vue'
import audioPlayer from '~/components/common/audioPlayer.vue'
export default {
  name: 'InvitationPage',
  components: { rsvpForm, audioPlayer },
  transition: "slide-bottom",
  async asyncData({ $axios, params, query, redirect }) {
     try {
        const urlWeddingApi = new URL(`/api/v1/public/weddings/${params.wedding_code}`)
        
        if(query.to) urlWeddingApi.searchParams.set('guest_code', query.to)

        const data = await $axios.$get(urlWeddingApi.toString())

        return { wedding: data.data, url: `https://bellioo.com/${params.wedding_code}` + (query.to && `?to=${query.to}`) }
     } catch (error) {
        redirect('/')
     }
  },
  data() {
    return {
      countdown: null,
      countdownData: {
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      attendances: [],
      isPlaying: false,
      personBgImage: require('@/assets/images/theme2/bg-overlay.webp')
    }
  },
   head() {
      const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
      return {
          htmlAttrs: {
              myAttribute: this.$i18n.locale,
              ...i18nHead.htmlAttrs
          },
          title: `${this.wedding.wife_nickname ?? this.wedding.wife} & ${this.wedding.husband_nickname ?? this.wedding.husband}`,
          meta: [
              {
                  hid: "description",
                  name: "description",
                  content: this.$t("makeSpecialDay")
              },
              {
                hid: 'keywords',
                name: 'description',
                content: this.$t("meta.description")
              },
              {
                hid: 'og:title',
                name: 'og:title',
                content: this.$t("meta.title"),
              },
              {
                hid: 'og:description',
                name: 'og:description',
                content: this.wedding.wedding_date ? this.$moment(this.wedding.wedding_date).format('dddd[,] D MMMM YYYY') : this.$t("meta.ogDescription")
              },
              {
                hid: 'og:site_name',
                name: 'og:site_name',
                content: 'Bellioo',
              },
              {
                hid: 'og:image',
                property: 'og:image',
                content:
                  this.wedding?.images[0].url ?? 'https://bellioo.com/logo.png',
              },
              {
                hid: 'og:url',
                name: 'og:url',
                content: this.url ?? 'https://bellioo.com',
              },
                {
                hid: 'og:type',
                name: 'og:type',
                content: `website`,
              },
              {
                hid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image',
              },
              {
                hid: 'twitter:site',
                name: 'twitter:site',
                content: '@andriarfazzan',
              },
              {
                hid: 'twitter:creator',
                name: 'twitter:creator',
                content: '@andriarfazzan',
              },
              {
                hid: 'twitter:url',
                name: 'twitter:url',
                content: `https://twitter.com/andriarfazzan`,
              },
              {
                hid: 'twitter:title',
                name: 'twitter:title',
                content: this.$t("weddingInvitation") + ` ${this.wedding.wife_nickname ?? this.wedding.wife} & ${this.wedding.husband_nickname ?? this.wedding.husband}`,
              },
              {
                hid: 'twitter:description',
                name: 'twitter:description',
                content: this.wedding.wedding_date ? this.$moment(this.wedding.wedding_date).format('dddd[,] D MMMM YYYY') : this.$t("meta.ogDescription")
              },
              {
                hid: 'twitter:image',
                name: 'twitter:image',
                content:
                   this.wedding.images[0].url ?? 'https://bellioo.com/logo.png',
              },
              ...i18nHead.meta
          ],
          link: [
              ...i18nHead.link
          ]
      };
  },
  computed:{
    isGuestExists(){
      return this.wedding.guests.length > 0
    },
    infiniteGallery(){
      if(this.wedding.gallery.length > 0 && this.wedding.gallery.length <= 30){
          const infinity = this.wedding.gallery
          infinity.concat(this.wedding.gallery, this.wedding.gallery)
          return infinity.slice(0,29)
      }
      return this.wedding.gallery
    }
  },
  mounted(){
    const cover = document.getElementById('cover')
    cover.style.backgroundImage = `url(${this.wedding.images[0].url ?? '~/assets/images/main-bg.webp'})`

    if(this.wedding.wedding_date){
      this.runCountDown()
    }

    this.getAttendances()

    this.$moment.updateLocale('id');
  },
  beforeDestroy() {
    // delete interval
    if(this.countdown) clearInterval(this.countdown)
  },
  methods:{
    openInvitation(){
      const body = document.getElementById('body')
      body?.classList.remove('hidden')
      body?.scrollIntoView({ behavior: 'smooth' })

      // AOS.refresh()
      this.isPlaying = true

      const cover = document.getElementById('cover')
      const addClass = ['-translate-y-full', 'transition', 'duration-1000']
      cover?.classList.add(...addClass)
      setInterval(() => cover?.classList.add('opacity-0'), 1000)
      
      // const person = document.getElementById('person')
      // person.style.backgroundImage = `url(${this.wedding.images[0].url})` ?? '~/assets/images/main-bg.webp'
    },
    runCountDown(){
      this.countdown = setInterval(() => {
            const {days, minutes, hours, interval} = getCountDown(this.wedding?.events[0]?.date ?? this.wedding.wedding_date)

            this.countdownData = {
              days: days < 10 ? '0'+ days : days,
              hours: hours < 10 ? '0'+ hours  : hours,
              minutes: minutes < 10 ? '0'+ minutes  : minutes,
            }
            if(interval < 0){
              clearInterval(this.countdown)
            }
          }, 1000);
    },
    getAttendances() {
      const urlApi =`/api/v1/public/attendances?wedding_id=${this.wedding.id}`
      this.$axios.get(urlApi).then(({data}) =>{
        this.attendances = data.data
      }).catch(() => {
          //
      })
    }
  }
}
</script>

<style scoped>
.main-bg, .person-cover, .surah-cover {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
}

.surah-cover {
  background-image: url('~/assets/images/theme2/backdrop-surat.webp');
  background-position: bottom !important;
}

.person-cover {
  background-position: start !important;
  min-height: max-content + 100px;
  height: 80vh;
  position: relative;
}

.main-bg::after, .person-cover::after {
  content: '';
  background-image: linear-gradient(0deg, rgba(0 0 0/ 40%), rgba(0 0 0/ 40%));
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.scroll-element {
  width: inherit;
  height: inherit;
  position: absolute;
  left: 0%;
  top: 0%;
}
.primary {
  animation: primary 60s linear infinite;
}

.secondary {
  animation: secondary 60s linear infinite;
}

@keyframes primary {
  from {
    /* left: 0%; */
    transform: translate3d(0, 0, 0);
  }
  to {
    /* left: -100%; */
    transform: translate3d(-1624px, 0, 0);
  }
}

@keyframes secondary {
  from {
    left: 100%;
  }
  to {
    left: 0%;
  }
}
</style>